import React, { useEffect, useState } from 'react';
import { getRecordedBrandsList, changeBrandStatus, deleteBrand } from '../services/brandService';
import { Row, Table, Button, Col, Form, Input, Select, Modal, Tag, message } from 'antd';
import BrandEdit from '../components/Brand/BrandEdit';
import CategoryUtils from '../common/CategoryUtils';
const { Option } = Select;
const { confirm } = Modal;
const PAGE_SIZE = 10;
const FIRST_PAGE = 1;

function RecordedBrandsList() {
    const [form] = Form.useForm()
    const [list, setList] = useState([]);
    const [totle, setTotal] = useState(0);
    const [tableLoading, setTableLoading] = useState(false);
    const [current, setCurrent] = useState(FIRST_PAGE);
    const [editVisible, setEditVisible] = useState(false);
    const [currentBrandId, setCurrentBrandId] = useState();
    const [params, setParams] = useState({
        id: '',
        name: '',
        nameCN: '',
        status: ''
    });
    let catTree = CategoryUtils.loadCategoryTree();
    const columns = [
        {
            title: '管理品牌ID',
            dataIndex: 'id',
            key: 'id',
            width: '250px',
        }, {
            title: '管理品牌',
            dataIndex: 'name',
            key: 'name'
        }, {
            title: '品牌中文名',
            dataIndex: 'nameCN',
            key: 'nameCN'
        }, {
            title: '商家品牌名',
            key: 'otherNames',
            render: (record) => (
                <div>{record.otherNames ? record.otherNames.join(',') : null}</div>
            )
        }, {
            title: 'app内展示名称',
            dataIndex: 'displayName',
            key: 'displayName'
        }, {
            title: '品牌别名',
            key: 'alias',
            render: (record) => (
                <div>{record.alias ? record.alias.join(',') : null}</div>
            )
        }, {
            title: '品牌归属国家/地区',
            dataIndex: 'country',
            key: 'country'
        }, {
            title: '等级',
            dataIndex: 'level',
            key: 'level'
        }, {
            title: '关联商家数',
            dataIndex: 'merchantCount',
            key: 'merchantCount'
        }, {
            title: '在线商品数',
            dataIndex: 'productCount',
            key: 'productCount'
        }, {
            title: '关联类目',
            key: 'associatedCategory',
            render: (record) => (
                catTree && record?.associatedCategory && <div>{CategoryUtils.searchLabelFromTreeById(catTree, record?.associatedCategory, `${record?.associatedCategory}-`)}</div>
            )
        }, {
            title: '所属类目', 
            key: 'belongedCategories',
            width: '180px',
            render: (record) => (
                record?.belongedCategories?.map(c => <Tag key={c}>{c}</Tag>)
            )
        }, {
            title: '操作',
            key: 'action',
            width: '250px',
            fixed: 'right',
            render: (record) => (
                <Row>
                    <Col span={8}>
                        <Button onClick={() => handleEditBrandClick(record)}>编辑</Button>
                    </Col>
                    <Col span={8}>
                        {record.status === 1 ?
                            <Button onClick={() => handleBrandStatusChange(record.id, 2)}>禁用</Button> :
                            <Button onClick={() => handleBrandStatusChange(record.id, 1)} type="primary">启用</Button>}
                    </Col>
                    <Col span={8}>
                        <Button onClick={() => handleDeleteBrand(record)} type="danger" ghost>删除</Button>
                    </Col>
                </Row>
            )
        }
    ]

    useEffect(() => {
        getBrandList(FIRST_PAGE);
    }, []);

    function getBrandList(currentPage, data) {
        setTableLoading(true);
        const p = data || params;
        const c = currentPage || current || 1;
        getRecordedBrandsList({
            f: c * 10 - PAGE_SIZE,
            t: c * 10,
            ...p
        }).then((res) => {
            setList(res.data.data);
            setTotal(res.data.total);
            setTableLoading(false);
        }).catch(() => {
            setTableLoading(false);
        })
    }

    function handleSubmit() {
        setList([]);
        setCurrent(FIRST_PAGE);
        form.validateFields().then((values) => {
            setParams(values);
            getBrandList(FIRST_PAGE, values);
        })
    }

    function handleAddNewBrand() {
        setCurrentBrandId('');
        setEditVisible(true);
    }

    function handleCurrentPageChange(page) {
        setList([]);
        getBrandList(page);
        setCurrent(page);
    }

    function handleBrandStatusChange(id, status) {
        changeBrandStatus(id, status).then(() => {
            getBrandList();
        })
    }

    function handleDeleteBrand(record) {
        confirm({
            title: `确定删除${record.name}品牌吗?`,
            okText: '确定',
            okType: 'danger',
            cancelText: '取消',
            onOk() {
                deleteBrand(record.id).then(() => {
                    getBrandList();
                }).catch(err => {
                    message.error(err.response?.data?.errors?.[0] || err.message)
                })
            }
        });
    }

    function closeEditModal() {
        setEditVisible(false);
    }

    function handleEditBrandClick(brand) {
        setEditVisible(true);
        setCurrentBrandId(brand.id);
    }

    function saveSuccess() {
        getBrandList();
        setEditVisible(false);
    }

    return (
        <div className='p-recorded-brands-list'>
            <Form layout='inline' name='recorded_brands_list' form={form}>
                <Form.Item label="管理品牌ID" name="id">
                    <Input allowClear />
                </Form.Item>
                <Form.Item label="管理品牌名称" name="name">
                    <Input allowClear />
                </Form.Item>
                <Form.Item label="品牌中文名" name="nameCN">
                    <Input allowClear />
                </Form.Item>
                <Form.Item label="状态" name="status" initialValue="">
                    <Select style={{ width: 120 }}>
                        <Option value="">全部</Option>
                        <Option value="1">启用</Option>
                        <Option value="2">禁用</Option>
                    </Select>
                </Form.Item>
                <Form.Item>
                    <Button type="primary" onClick={handleSubmit}>
                        查询
                    </Button>
                </Form.Item>
                <Form.Item>
                    <Button type="primary" ghost onClick={handleAddNewBrand}>
                        新增
                    </Button>
                </Form.Item>
            </Form>
            <br />
            <Table
                style={{backgroundColor: '#ffffff'}}
                tableLayout='fixed'
                columns={columns}
                dataSource={list}
                loading={tableLoading}
                rowKey={record => record.id}
                scroll={{ x: 2000 }}
                pagination={{
                    pageSize: PAGE_SIZE,
                    total: totle,
                    showQuickJumper: true,
                    current: current,
                    onChange: handleCurrentPageChange,
                    style: {
                        paddingRight: '20px'
                    }
                }}
            />
            <BrandEdit
                visible={editVisible}
                onCancel={closeEditModal}
                brandId={currentBrandId}
                saveSuccess={saveSuccess}
            />
        </div>
    )
}

export default RecordedBrandsList;